import { StudioLayout } from "@/Components/Layouts";
import { Box, Center, Container, Grid, Paper } from "@mantine/core";
import { queryGetAd } from "@/Services/studio-query-v1";
import { AdPreview } from "@/Pages/Studio/AdBuilder/Form/AdPreview";
import { IntegrationPreview } from "@/Pages/Studio/AdBuilder/Form/IntegrationPreview";
import { PreviewPane } from "@/Pages/Studio/AdBuilder/Form/PreviewPane";
import { BookingFlowHeader } from "..";
import { useMemo, useRef } from "react";
import { PendingChangesNotice } from "./bookingflow-notification";
import { useTranslation } from "react-i18next";
import stepClasses from "@/Pages/Studio/AdBuilder/BookingFlow/bookingflow-steps.module.css";

export const BookingFlowLayout = ({ children, leftSection, rightSection, bottomSection, paperProps, showPendingChanges, onPendingChangesClose }) => {

    const { t } = useTranslation();

    const query = queryGetAd(route().params.ad);
    const formatType = query?.data?.ad?.ad_banner_formats?.[0]?.banner_format?.alias || 'medium_rectangle';
    const showPreview = ['medium_rectangle', 'halfpage'].includes(formatType);

    const previewQuery = useMemo(() => ({ data: { ...query?.data?.assets } }), [query?.data?.assets]);
    const previewRef = useRef(null);
    const hasPreviewColumn = Boolean(query?.data && showPreview);

    return (
        <>
            <StudioLayout pageTitle={t('ads.editPageTitle')} withBottomNav={false}>
                <BookingFlowHeader leftSection={leftSection} rightSection={rightSection} />
                <Container size="xl" p={{ base: 0, sm: 'lg' }} className={stepClasses.flowRoot}>
                    <Grid gutter={{ base: 0, md: 'md' }}>
                        <Grid.Col span={{ base: 12, md: showPreview ? 8 : 12 }} >
                            <Paper shadow="xs" radius={16} withBorder className={stepClasses.flowPaper} {...(paperProps?.p === undefined && { px: { base: 16, sm: 24 }, py: 24 })} {...paperProps}>
                                {children}
                            </Paper>
                            {bottomSection && <Box className={stepClasses.flowBottom}>{bottomSection}</Box>}
                            {(showPendingChanges && !hasPreviewColumn) && (
                                <Box mt={24}>
                                    <PendingChangesNotice onClose={onPendingChangesClose} />
                                </Box>
                            )}
                        </Grid.Col>
                        {
                            hasPreviewColumn && (
                                <Grid.Col span={{ base: 12, md: 4 }} pt="sm">
                                    <div ref={previewRef}>
                                        <PreviewPane>
                                            <Center>
                                                {previewQuery?.data?.ad_preview_integration ? (
                                                    <IntegrationPreview singleAdQuery={previewQuery} format={formatType} />
                                                ) : (
                                                    <AdPreview singleAdQuery={previewQuery} />
                                                )}
                                            </Center>
                                        </PreviewPane>
                                    </div>
                                    {showPendingChanges && (
                                        <PendingChangesNotice anchorRef={previewRef} onClose={onPendingChangesClose} />
                                    )}
                                </Grid.Col>
                            )}
                    </Grid>
                </Container>
            </StudioLayout>
        </>
    );
}